'use client';

import { IoIosArrowForward } from '@react-icons/all-files/io/IoIosArrowForward';
import React from 'react';
import { IAlternative } from '../../types';
import { CustomLink } from '../link/link.comp';
import { StyledDiv } from './alternativeCollection.styles';

interface IAlternativeCollectionProps {
    alternatives: IAlternative[];
}

export const AlternativeCollection = ({ alternatives }: IAlternativeCollectionProps) => {
    if (!alternatives.length) return <></>;

    return (
        <StyledDiv>
            <div className="text-section">
                <h3>What’s the best widget company for you?</h3>
                <p>Learn why thousands of people choose Common Ninja</p>
            </div>

            <div className="links">
                {alternatives.map((a) => (
                    <CustomLink className='link' variant='secondary' key={a.slug} href={`/alternatives/${a.slug}`}>
                        Common Ninja vs. {a.name}
                        <IoIosArrowForward fontSize={18} className='icon' />
                    </CustomLink>
                ))}
            </div>
        </StyledDiv>
    );
};

